import * as _ from 'underscore';
import { ConfirmModal } from './confirmModal';
import { Table, Util } from '..';
import { DataSource } from '../data';
import { SelectionMode } from '../../enums';
import { ListConfirmModalOptions } from '../../interfaces/options';
import { DefaultListConfirmModalOptions } from '../../const/defaultOptions';
import { Localization } from '../../compile';

export class ListConfirmModal<T> extends ConfirmModal {
	protected table: Table<T>;
	public selected: KnockoutObservableArray<T> | KnockoutObservable<T>;

	constructor(options: ListConfirmModalOptions<T>) {
		options = $.extend(
			true,
			{},
			DefaultListConfirmModalOptions,
			{
				confirmLabel: Localization.Apply
			},
			options || {}
		);
		super(options);

		this.table = new Table<T>(options.table);
		var _selectionmode = this.table.selectionMode();

		if (options.selected === undefined) {
			this.selected =
				_selectionmode == SelectionMode.SINGLE
					? ko.observable<T>()
					: _selectionmode == SelectionMode.MULTIPLE
						? ko.observableArray<T>()
						: null;
		} else {
			if (_selectionmode == SelectionMode.MULTIPLE) {
				if (_.isArray(options.selected())) {
					this.selected = options.selected;
				} else {
					new Error('Argument expection: parameter selected has to be an observableArray');
				}
			} else if (_selectionmode == SelectionMode.SINGLE) {
				this.selected = options.selected;
			} else {
				this.selected = null;
			}
		}

		this.Opened.subscribe(() => {
			this.clearSelection();
			let selected;
			if (this.selected && (selected = this.selected())) {
				switch (this.table.selectionMode()) {
					case SelectionMode.SINGLE:
						this.table.selectItem(<T>selected);
						break;
					case SelectionMode.MULTIPLE:
						//id necessary -  better solution may inject in _selectedItems
						this.table.selectItems(<T[]>selected);
						break;
					default:
						throw new Error('invalid selection mode');
				}
			}
		});
		this.Confirmed.subscribe(() => {
			let selected = this.table.selectedItems;
			if (selected) {
				switch (this.table.selectionMode()) {
					case SelectionMode.SINGLE:
						(<KnockoutObservable<T>>this.selected)(selected[0]);
						break;
					case SelectionMode.MULTIPLE:
						(<KnockoutObservableArray<T>>this.selected)(Util.cloneArray(<T[]>selected));
						break;
					default:
						throw new Error('invalid selection mode');
				}
			}
		});
	}
	public reload(selection?: string | string[], property?: string): Promise<DataSource<T>> {
		return this.table.reload().then(ds => {
			if (selection) {
				if (_.isArray(<string[]>selection) && (<string[]>selection).length > 0) {
					this.selectItemsBy(<string[]>selection, property);
				} else {
					this.selectItemBy(<string>selection, property);
				}
			}
			return Promise.resolve(ds);
		});
	}
	public getSelectedItem(): T {
		if (this.table.selectionMode() == SelectionMode.SINGLE) {
			return <T>this.selected();
		}
		throw new Error('invalid selection mode');
	}
	public getSelectedItems(): T[] {
		if (this.table.selectionMode() == SelectionMode.MULTIPLE) {
			return <T[]>this.selected();
		}
	}
	public selectItemsBy(value: string[], property: string = this.table.idProperty): T[] {
		if (this.table.selectionMode() == SelectionMode.MULTIPLE) {
			let selectedItems: T[] = _.filter(this.table.dataSource.data(), item => {
				return _.contains(value, Util.getProperty(item, property));
			});
			(<KnockoutObservableArray<T>>this.selected)(Util.cloneArray(selectedItems));
			return selectedItems;
		}
		throw new Error('invalid selection mode');
	}
	public selectItemBy(value: string, property: string = this.table.idProperty): T {
		let selectedItem: T;
		if (
			(selectedItem = _.find(
				this.table.dataSource.data(),
				item => Util.getProperty(item, property) == value
			))
		) {
			switch (this.table.selectionMode()) {
				case SelectionMode.SINGLE:
					(<KnockoutObservable<T>>this.selected)(selectedItem);
					break;
				case SelectionMode.MULTIPLE:
					(<KnockoutObservableArray<T>>this.selected).push(selectedItem);
					break;
				default:
					throw new Error('invalid selection mode');
			}
		}
		return selectedItem;
	}
	public clearSelection() {
		this.table.clearSelection();
	}
}
